import { getAccessToken, devBypass } from "./auth.js";

// Dev bypass only: which pretend user and roles to send. Switchable from the top bar.
export const devIdentity = {
  get user() { try { return localStorage.getItem("foodshow.devUser") || "0001"; } catch { return "0001"; } },
  get roles() { try { return localStorage.getItem("foodshow.devRoles") || "rep"; } catch { return "rep"; } },
  get kind() { try { return localStorage.getItem("foodshow.devKind") || "internal"; } catch { return "internal"; } },
  set(user, roles, kind = "internal") { try { localStorage.setItem("foodshow.devUser", user); localStorage.setItem("foodshow.devRoles", roles); localStorage.setItem("foodshow.devKind", kind); } catch { /* ignore */ } },
};

export class ApiError extends Error {
  constructor(status, body) { super(body?.error ?? `HTTP ${status}`); this.status = status; this.details = body?.details; }
}

/** JSON fetch with bearer token and an Idempotency-Key for anything that changes data. */
export async function api(path, { method = "GET", body, idempotencyKey } = {}) {
  const headers = { accept: "application/json" };
  const token = await getAccessToken();
  if (token) headers.authorization = `Bearer ${token}`;
  if (devBypass) {
    headers["x-dev-user"] = devIdentity.user;
    if (devIdentity.kind === "external") headers["x-dev-kind"] = "external";
    // External pretend identities take roles from grants, like the real thing, unless forced.
    if (devIdentity.kind !== "external" || devIdentity.roles !== "granted") headers["x-dev-roles"] = devIdentity.roles;
  }
  if (body !== undefined) headers["content-type"] = "application/json";
  if (idempotencyKey) headers["idempotency-key"] = idempotencyKey;

  const res = await fetch(`/api${path}`, { method, headers, body: body === undefined ? undefined : JSON.stringify(body) });
  const data = res.status === 204 ? null : await res.json().catch(() => null);
  if (!res.ok) throw new ApiError(res.status, data);
  return data;
}

/** One key per form submission: generated when the form is first shown, reused on every retry. */
export const newIdempotencyKey = () => crypto.randomUUID();
